// @flow

import React, { Component } from 'react';

import MatchsResultsTournament from 'components/competitionsInternationales/competitionsInternationalesMatchsResultsTournament';
import MatchsResultsWorldCup from 'components/competitionsInternationales/competitionsInternationalesMatchsResultsWorldCup';
import DropdownMultiInput from 'components/fragments/input/DropdownMultiInput';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import { STATUS_SUCCESS } from 'constants/statusConstants';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { CompetitionInternationale } from 'types/competitionsInternationales';
import type { Status } from 'types/Status';
import { TOURNAMENT_TYPE, WORLD_CUP_TYPE } from 'constants/matchsResultsConstant';

import './CompetitionsInternationalesMatchsResults.css';

export type StateProps = {
  data: CompetitionInternationale,
  status: Status
};

type Props = StateProps;

type State = {
  filter: Set<string>
};

export const LIVE = 'live';
export const TO_COME = 'toCome';
export const OVER = 'over';
export const OPTIONS = [
  { value: LIVE, label: 'En direct' },
  { value: TO_COME, label: 'À venir' },
  { value: OVER, label: 'Terminé' }
];

export const DEFAULT_OPTIONS = [LIVE, TO_COME, OVER];

class CompetitionsInternationalesMatchsResults extends Component<Props, State> {
  state = {
    filter: new Set(DEFAULT_OPTIONS)
  };

  onFilterChange = (value: string) => {
    this.setState(({ filter }) => {
      const newFilter = new Set(filter);
      if (newFilter.has(value)) {
        newFilter.delete(value);
      } else {
        newFilter.add(value);
      }

      return {
        filter: newFilter
      };
    });
  };

  render() {
    const { data } = this.props;
    const { filter } = this.state;

    let allMatchs = data.prochaines_rencontres.concat(data.dernieres_rencontres);
    if (!allMatchs || !allMatchs.length) {
      return null;
    }

    let pageTitle = `Calendrier et Résultats`;
    if (data.title.raw.match(/Coupe /) || data.title.raw.match(/coupe /)) {
      pageTitle = `${pageTitle} de la ${data.title.raw}`;
    } else if (data.title.raw.match(/Tournoi /) || data.title.raw.match(/tournoi /)) {
      pageTitle = `${pageTitle} du ${data.title.raw}`;
    } else {
      pageTitle = `${pageTitle} des ${data.title.raw}`;
    }

    return (
      <>
        <section className="matchs-results">
          {!!data &&
            !!data.top_content_matchs_resultats &&
            !!data.top_content_matchs_resultats.data &&
            !!data.top_content_matchs_resultats.data.length &&
            data.top_content_matchs_resultats.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)}
          <div className="dropdown-container">
            <h2>{pageTitle}</h2>
            <DropdownMultiInput
              label="Trier"
              options={OPTIONS}
              inputChanged={this.onFilterChange}
              selected={Array.from(filter)}
              className={'dropdown dropdown--noBorder dropdown--checkbox'}
            />
          </div>

          {TOURNAMENT_TYPE.includes(data.meta.competition_layout_type) && (
            <MatchsResultsTournament allMatchs={allMatchs} filter={filter} equipeNom={data.meta.equipeNom} />
          )}

          {WORLD_CUP_TYPE.includes(data.meta.competition_layout_type) && (
            <MatchsResultsWorldCup allMatchs={allMatchs} filter={filter} equipeNom={data.meta.equipeNom} />
          )}
        </section>
        <div className="mt-7">
          {!!data &&
            !!data.content_matchs_resultats &&
            !!data.content_matchs_resultats.data &&
            !!data.content_matchs_resultats.data.length &&
            data.content_matchs_resultats.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)}
        </div>
      </>
    );
  }
}

export default withHelmet(CompetitionsInternationalesMatchsResults)((Helmet, pageProps: Props) => {
  const { data, status } = pageProps;

  if (status !== STATUS_SUCCESS || !data) {
    null;
  }

  const meta_title = `Résultats & Calendrier des Matchs - ${data.title.raw} - FFR`;

  return (
    <Helmet htmlAttributes={{ lang: 'fr' }}>
      {meta_title && <title>{meta_title}</title>}
      {meta_title && <meta property={'og:title'} content={meta_title} />}
    </Helmet>
  );
});
